import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromShared from './shared.reducer';

export const SHARED_STATE_NAME = 'shared';

export const stateSelector =
  createFeatureSelector<Readonly<fromShared.State>>(SHARED_STATE_NAME);
export const loadingStatus = createSelector(
  stateSelector,
  (state) => state.showLoading
);

export const agency = createSelector(stateSelector, (state) => state.agency);
export const enterprise = createSelector(stateSelector, (state) => state.agency);
export const position = createSelector(stateSelector, (state) => state.position)
export const positionBranch = createSelector(stateSelector, (state) => state.positionBranch)



